<div class="flex flex-col h-full min-h-0">
  <hs-tab-group class="flex-1 min-h-0 overflow-y-auto">
    <hs-tab label="{{ addressTabLabel }}">
      <hs-contact-form
        class="layer-two"
        [(contact)]="selectedContact"
      ></hs-contact-form>
    </hs-tab>
    <hs-tab label="{{ bankTabLabel }}">
      <kfm-contact-bank-account-form
        class="layer-two"
        [bankAccount]="bankAccount"
        [contactType]="selectedContact.contactType"
      ></kfm-contact-bank-account-form>
    </hs-tab>
    <hs-tab label="{{ idTabLabel }}">
      <kfm-contact-registrations
        class="layer-two"
        [registrations]="registrations"
        [contactType]="selectedContact.contactType"
        [contactUid]="selectedContact.uId"
        (hasDuplicateCustomerNumber)="hasDuplicateCustomerNumber.set($event)"
      ></kfm-contact-registrations>
    </hs-tab>
  </hs-tab-group>

  <div class="flex flex-row w-full justify-end gap-2 p-2 flex-shrink-0">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelButtonLabel }}
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      [disabled]="!canSave"
      (click)="onOkClicked()"
    >
      {{ okButtonLabel }}
    </button>
  </div>
</div>
